module.exports = __webpack_public_path__ + "static/media/sell_help_3b.d3f195b0.jpg";